/**
 * @generated SignedSource<<175544173c4631060221cbb405364177>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type CheckoutPageHeader_viewer$data = {
  readonly item: {
    readonly " $fragmentSpreads": FragmentRefs<"AbandonCheckoutModal_item" | "BuyerIncentives_item" | "CheckoutCancelationPolicy_item">;
  } | null;
  readonly " $fragmentSpreads": FragmentRefs<"BuyerIncentives_viewer" | "CheckoutHeaderBanner_viewer">;
  readonly " $fragmentType": "CheckoutPageHeader_viewer";
};
export type CheckoutPageHeader_viewer$key = {
  readonly " $data"?: CheckoutPageHeader_viewer$data;
  readonly " $fragmentSpreads": FragmentRefs<"CheckoutPageHeader_viewer">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [
    {
      "kind": "RootArgument",
      "name": "itemId"
    }
  ],
  "kind": "Fragment",
  "metadata": null,
  "name": "CheckoutPageHeader_viewer",
  "selections": [
    {
      "alias": null,
      "args": [
        {
          "kind": "Variable",
          "name": "itemId",
          "variableName": "itemId"
        },
        {
          "kind": "Literal",
          "name": "pageType",
          "value": "CHECKOUT"
        }
      ],
      "concreteType": "Item",
      "kind": "LinkedField",
      "name": "item",
      "plural": false,
      "selections": [
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "AbandonCheckoutModal_item"
        },
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "CheckoutCancelationPolicy_item"
        },
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "BuyerIncentives_item"
        }
      ],
      "storageKey": null
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "CheckoutHeaderBanner_viewer"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "BuyerIncentives_viewer"
    }
  ],
  "type": "Viewer",
  "abstractKey": null
};

(node as any).hash = "215b55f2176f391b64b80774bf7ff4e1";

export default node;
